import { Icon } from "@iconify/react"
import { TypographySmall, TypographySmallMuted } from "@/components/ui/typography.jsx"
import { useNavigate, useLocation } from "react-router-dom"
import { SpaceSelector } from "@/components/space-selector/SpaceSelector"

export const SettingsSubNavbar = () => {
    const navigate = useNavigate()
    const { pathname } = useLocation()

    // Update isActive to match the correct path format
    const isActive = (path) => pathname.includes(`settings/${path}`)

    // Create a helper function to handle navigation
    const navigateTo = (path) => {
        navigate(`settings/${path}`)
    }

    return (
        <div className="p-4 flex flex-col gap-6">
            <div className="flex flex-col gap-1">
                <TypographySmall className="flex items-center gap-2">
                    <Icon icon="eos-icons:organisms" className="h-4 w-4" />
                    Account
                </TypographySmall>
                <div className="flex flex-col mt-2 gap-1">
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent p-2 rounded transition ${isActive('account/general') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('account/general')}
                    >
                        General
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent p-2 rounded transition ${isActive('account/spaces') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('account/spaces')}
                    >
                        Spaces
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent p-2 rounded transition ${isActive('account/data-connections') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('account/data-connections')}
                    >
                        Data Connections
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent p-2 rounded transition ${isActive('account/members') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('account/members')}
                    >
                        Members
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent p-2 rounded transition ${isActive('account/billing') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('account/billing')}
                    >
                        Plan & Billing
                    </TypographySmallMuted>
                </div>
            </div>

            <div className="flex flex-col gap-1">
                <TypographySmall className="flex items-center gap-2">
                    <Icon icon="material-symbols-light:planet-outline-rounded" className="h-4 w-4 flex-shrink-0" />
                    Space
                </TypographySmall>
                <div className="flex flex-col mt-2 gap-1">
                    <SpaceSelector size="sm" />
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent p-2 rounded transition ${isActive('space/general') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('space/general')}
                    >
                        General
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent p-2 rounded transition ${isActive('space/data-sources') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('space/data-sources')}
                    >
                        Data Sources
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent p-2 rounded transition ${isActive('space/data-config') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('space/data-config')}
                    >
                        Data Config
                    </TypographySmallMuted>
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent p-2 rounded transition ${isActive('space/members') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('space/members')}
                    >
                        Members
                    </TypographySmallMuted>
                </div>
            </div>

            <div className="flex flex-col gap-1">
                <TypographySmall className="flex items-center gap-2">
                    <Icon icon="solar:user-broken" className="h-4 w-4" />
                    My User
                </TypographySmall>
                <div className="flex flex-col gap-1">
                    <TypographySmallMuted
                        className={`cursor-pointer hover:bg-accent p-2 rounded transition ${isActive('user/details') ? 'bg-accent' : ''}`}
                        onClick={() => navigateTo('user/details')}
                    >
                        General
                    </TypographySmallMuted>
                </div>
            </div>
        </div>
    )
}